/** How many designs load at once — the first page on open, and each press of Load More. */
export const DESIGN_PAGE_SIZE = 10;
